module.exports = __webpack_public_path__ + "img/Woman-9.9f350e7c.svg";